import React from "react";

import "./style.css";

function Button(props) {
  return <button className="button_default">{props.title}</button>;
}

export default Button;
